import { initialState } from "./index";

export default () => initialState;
